import {Component} from '@angular/core';
import {AppRouter} from "@app/app.router";
import {ENV} from "@env";
import {UserConverter} from "@utils/converter/user-converter";
import {UserTeamConverter} from "@utils/converter/user-team-converter";
import {IonicPage, NavParams} from 'ionic-angular';
import {
  ConversationsSettingProvider,
  MessengerProvider,
  UsersProvider,
  UserTeamsProvider,
  UserTeamVoData,
  UserVoData
} from 'od-ts';
import {DecoratedAvatarData, WelcomeData} from 'ui-ts';

@IonicPage({
  segment: ':organization/:context/welcome'
})
@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html',
})
export class WelcomePage {
  private _data: WelcomeData;
  private _canEnter: any;

  constructor(private navParams: NavParams,
              private router: AppRouter,
              private _messengerProvider: MessengerProvider,
              private _usersProvider: UsersProvider,
              private _userTeamsProvider: UserTeamsProvider,
              private _conversationsSettingProvider: ConversationsSettingProvider) {
    this._data = new WelcomeData();
    this._data.avatars = [];
  }

  ionViewCanEnter(): boolean {
    this._canEnter = this.router.navTo('WelcomePage', this.navParams.data);
    return this._canEnter;
  }

  ionViewWillEnter() {
    if (this._canEnter) {
      this.setup();
    }
  }

  private setup() {
    this._messengerProvider.model.setWelcomeVisited(true);
    document.body.classList.add("od-visual-composer-simple-line");
    this._data.avatars = [];
    if (this._conversationsSettingProvider.model.liveSupportOnline) {
      this._data.text = this._conversationsSettingProvider.model.workingHoursMessage;
      this._usersProvider.get(this._conversationsSettingProvider.model.userIds, (res) => {
        this._conversationsSettingProvider.model.userIds.forEach((userId) => {
          let user = res.get(userId);
          if (user != null) this._data.avatars.push(this.renderUserDecoratedAvatar(user))
        });
      });
      this._userTeamsProvider.get(this._conversationsSettingProvider.model.userTeamIds, (res) => {
        this._conversationsSettingProvider.model.userTeamIds.forEach((userTeamId) => {
          let userTeam = res.get(userTeamId);
          if (userTeam != null) this._data.avatars.push(this.renderTeamDecoratedAvatar(userTeam))
        });
      });
    } else {
      this._data.text = this._conversationsSettingProvider.model.notWorkingHoursGreetingMessage;
      let decoratedAvatar = this.renderUserDecoratedAvatar(this._usersProvider.model.get(-2));
      this._data.avatars.push(decoratedAvatar);
    }
  }

  private renderUserDecoratedAvatar(user: UserVoData, decoratedAvatarData?: DecoratedAvatarData): DecoratedAvatarData {
    decoratedAvatarData = UserConverter.convertToDecoratedAvatarData(user, ENV.fileUrl, decoratedAvatarData);
    decoratedAvatarData.avatarSize = 60;
    if(user.profile.displayName != null) decoratedAvatarData.displayName = user.profile.displayName;
    decoratedAvatarData.hideType = true;
    decoratedAvatarData.hideStatus = true;
    decoratedAvatarData.disabled = false;
    decoratedAvatarData.hideName = false;
    return decoratedAvatarData;
  }

  private renderTeamDecoratedAvatar(userTeam: UserTeamVoData, decoratedAvatarData?: DecoratedAvatarData): DecoratedAvatarData {
    decoratedAvatarData = UserTeamConverter.convertToDecoratedAvatarData(userTeam, ENV.fileUrl, decoratedAvatarData);
    decoratedAvatarData.avatarSize = 52;
    decoratedAvatarData.hideType = true;
    decoratedAvatarData.hideStatus = true;
    decoratedAvatarData.disabled = false;
    decoratedAvatarData.hideName = false;
    return decoratedAvatarData;
  }
}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts